import * as React from 'react'

import { Page, Container, Header, Button, Icon } from 'tabler-react'

const ErrorPage402 = (props) => {

  const {
    title,
    subtitle,
    details
  } = props

  const _onBackClick = (
   
  ): boolean => {
    window.history.back();
    event.preventDefault();
    return true;
  };

  return(
    <Page className="text-center">
      <Container>
        <Header.H1 className="display-1 text-muted mb-5">{title}</Header.H1>
        <Header.H2>{subtitle}</Header.H2>
        {details && (
          <Header.H4 className="text-muted font-weight-normal mb-7">
            {details}
          </Header.H4>
        )}
        <Button onClick={_onBackClick} className="btn-primary">
          <Icon className="mr-2" name="arrow-left" />
          Go back
        </Button>
      </Container>
    </Page>
  )
}

export default ErrorPage402